module.exports = "No campaign found\n\nwith name **\"{{query}}\"**"


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/en/noCampaignFoundForSearch.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/en/noCampaignFoundForSearch.md
// module chunks = 18